module.exports = __webpack_public_path__ + "static/media/auth-page-bg.ef6d26a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth-page-bg.jpg
// module id = 95
// module chunks = 0